import { ScaleManager } from "./Utils/ScaleManager";
import { AssetLoader } from "./Utils/AssetLoader";
import { Gameplay } from "./Gameplay/Gameplay";
import * as Gamee from "./SDK/Gamee/GameeWrapper";
import * as GameeSDK from "./SDK/Gamee/Gamee";
import { PathGenerator } from "./Gameplay/Game World/Game Map/PathGenerator";
import { RND } from "./Utils/RND";
import { SoundManager } from "./Utils/SoundManager";
import { MissionManager } from "./Gameplay/Gamee Missions/MissionManager";
import { SaveState } from "./SaveState";
import { eAdMode, SDKBase } from "./SDK/SDKBase";
import { OK } from "./SDK/OK";
import { VK } from "./SDK/VK";


//export const FPS_METER = new FPSMeter(undefined, { graph: 1 });


export const enum eModelAsset {
    tileSolid_0 = "tileSolid_0",
    tileSolid_1 = "tileSolid_1",
    tileSolid_2 = "tileSolid_2",
    tileFragile_0 = "tileFragile_0",
    tileFan_0 = "tileFan_0",

    fxLaser = "fxLaser",
    fxFan = "fxFan",

    tileTrampoline_0 = "tileTrampoline_0",
    trampOverlay_0 = "trampOverlay_0",

    obsColumn_0 = "obsColumn_0",
    obsGate_0 = "obsGate_1",
    obsWall_0 = "obsWall_0",
    obsFlying_0 = "obsFlying_0",
    obsRolling_0 = "obsRolling_0",
    hammer = "obsHammer",
    pillar_0 = "obsHammerPillarZ",
    pillar_1 = "obsHammerPillarY",

    laserCannon = "laserCannon",
    laserBeam = "laserBeam",

    bonus_0 = "bns_0",
    bonus_1 = "bns_1",

    platform1 = "plat1",
    platform2 = "plat2",

    player = "football",

    bgRing = "bgRing",
}



export const enum eAnimAsset {
    showObsColumn_0 = "showObsColumn"
}



export const enum eFontAsset {
    default = "fntDefault",
}



export const enum eTextureAsset {
    background = "bg",
    particles = "particles",
}



export const enum eAtlas_0 {
    NAME = "atlas_0",

    shadowSquare = "shadowSquare",
    shadowRect = "shadowRectangle",
    shadowCircle = "shadowCircle",
    shadowTunnel = "shadowTunnel",

    tutHand = "tutorHand",
    tutTouchFx = "tutorTouchFx",
    tutLine = "tutorLine",

    btnAudioOn_0 = "btnAudioOn_0",
    btnAudioOn_1 = "btnAudioOn_1",
    btnAudioOff_0 = "btnAudioOff_0",
    btnAudioOff_1 = "btnAudioOff_1",
    btnInvite_0 = "btnInvite_0",
    btnInvite_1 = "btnInvite_1",

    lblScore = "lblScore",
    lblHighScore = "lblHighScore",
    lblNewHighScore = "lblNewHighScore",
    btnExtraLife_0 = "btnExtraLife_0",
    btnExtraLife_1 = "btnExtraLife_1",
    btnNewGame_0 = "btnNewGame_0",
    btnNewGame_1 = "btnNewGame_1",
}



export const SfxSprites = {
    "bonusCollect": {
        "start": 0,
        "end": 0.8628344671201814,
        "loop": false
    },
    "fall": {
        "start": 2,
        "end": 3.6878231292517007,
        "loop": false
    },
    "hammerHit": {
        "start": 5,
        "end": 5.978503401360545,
        "loop": false
    },
    "hammerSpin": {
        "start": 7,
        "end": 7.7081179138322,
        "loop": false
    },
    "laserBeam": {
        "start": 9,
        "end": 11.769410430839002,
        "loop": false
    },
    "obstacleHit": {
        "start": 13,
        "end": 13.978412698412699,
        "loop": false
    },
    "platform": {
        "start": 15,
        "end": 15.79968253968254,
        "loop": false
    },
    "pwuActivation": {
        "start": 17,
        "end": 17.5,
        "loop": false
    },
    "rollingObstacle": {
        "start": 19,
        "end": 24.50002267573696,
        "loop": false
    },
    "slide": {
        "start": 26,
        "end": 26.770702947845805,
        "loop": false
    },
    "tileActivation": {
        "start": 28,
        "end": 28.309455782312924,
        "loop": false
    },
    "trampoline": {
        "start": 30,
        "end": 30.66013605442177,
        "loop": false
    },
    "vertObsHit": {
        "start": 32,
        "end": 33.3034693877551,
        "loop": false
    },
    "vertObsUp": {
        "start": 35,
        "end": 36.06965986394558,
        "loop": false
    }
}



export const enum eAudioAsset {
    sfx = "sfx",
    music = "music"
}



export const enum eSfxSprite {
    bonusCollect = "bonusCollect",
    fall = "fall",
    hammerHit = "hammerHit",
    hammerSpin = "hammerSpin",
    laserBeam = "laserBeam",
    explosion = "obstacleHit",
    platform = "platform",
    pwuActivation = "pwuActivation",
    rollingObstacle = "rollingObstacle",
    slide = "slide",
    tileActivation = "tileActivation",
    trampoline = "trampoline",
    vertObsHit = "vertObsHit",
    vertObsUp = "vertObsUp"
}



export const enum eLogEvent {
    death = "DEATH_DISTANCE"
}



export const enum eGameAPI {
    GAMEE,
    OK,
    VK
}



/**
 * Global random number generator
 */
export const rnd = new RND(Math.random() * 7548624);



export class Game {
    static readonly MAP_ASSET_KEY = "maps_";

    /**
     * Typ API, ktere hra pouziva
     */
    static readonly API: eGameAPI = eGameAPI.GAMEE;

    /**
     * (RO) pc.Application
     */
    static get app(): pc.Application { return Game._app; }
    private static _app: pc.Application;

    static get sdk(): SDKBase { return this._sdk; }
    private static _sdk: SDKBase;

    /**
     * (RO) Scale manager
     */
    static get scale(): ScaleManager { return this._scale; }
    private static _scale: ScaleManager

    /**
     * (RO) True, pokud je hra pozastavena
     */
    static get paused(): boolean { return Game._paused; }
    private static _paused: boolean = false;

    private static _loader: AssetLoader;
    private static _textureAtlas: pc.TextureAtlas;

    /**
     * (RO) Mise
     */
    static get missions(): MissionManager { return Game._missions; }
    private static _missions: MissionManager;

    /**
     * Index asset spritu se zvukovymi efekty
     */
    static get sfxSpriteAssetId(): number { return Game._sfxSpriteAssetId; }
    private static _sfxSpriteAssetId: number;

    private _gameplay: Gameplay;

    private static readonly _FLAG_SDK_INITIALIZED = 0x0001;
    private static readonly _FLAG_ASSETS_LOADED = 0x0002;

    private _flags: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(canvasID: string) {
        let canvas = document.getElementById(canvasID) as HTMLCanvasElement;

        this._flags = 0;

        // Vytvorit pc.Application
        Game._app = new pc.Application(canvas, { keyboard: new pc.Keyboard(window), elementInput: new pc.ElementInput(canvas) });

        if (pc.platform.touch) {
            Game._app.touch = new pc.TouchDevice(canvas);
        }
        else {
            Game._app.mouse = new pc.Mouse(canvas);
        }

        Game._app.setCanvasFillMode(pc.FILLMODE_NONE);
        Game._app.addTweenManager();
        Game._app.start();

        if (Game.API == eGameAPI.GAMEE) {
            // Mise
            Game._missions = new MissionManager();

            // Gamee
            Gamee.Wrapper.EVENTS.on(Gamee.eEvent.start, () => { Game._paused = false; });
            Gamee.Wrapper.EVENTS.on(Gamee.eEvent.pause, () => { SoundManager.pause(); Game._paused = true; });
            Gamee.Wrapper.EVENTS.on(Gamee.eEvent.resume, () => { SoundManager.resume(); Game._paused = false; });
            Gamee.Wrapper.EVENTS.on(Gamee.eEvent.mute, () => { SoundManager.stop(); SoundManager.mute = true; });

            Gamee.Wrapper.gameInit([GameeSDK.eCapability.logEvents, GameeSDK.eCapability.missions, GameeSDK.eCapability.extraLife], () => {
                if (Gamee.Wrapper.INIT_DATA) {
                    let initData = Gamee.Wrapper.INIT_DATA;

                    // Povolit/zakazat zvuk
                    SoundManager.mute = !initData.sound;

                    if (initData.missionData) {
                        let missionData = (typeof initData.missionData == "string" ? JSON.parse(initData.missionData) : initData.missionData);
                        let targetVal = 0;

                        if (missionData.value)
                            targetVal = <number>(typeof missionData.value == "string" ? parseInt(missionData.value) : missionData.value);

                        Game._missions.setActiveMission(missionData.id, targetVal);
                    }
                }

                this.handleInitProgress(Game._FLAG_SDK_INITIALIZED);
            }, this);
        }
        else {
            Game._app.on(SDKBase.EVENT_INITIALIZED, (res: boolean) => {
                // Nacist reklamu
                Game._sdk.loadAd(eAdMode.videoReward);

                this.handleInitProgress(Game._FLAG_SDK_INITIALIZED);
            });
            Game._sdk = (Game.API == eGameAPI.OK ? new OK(Game._app) : new VK(Game._app));
            Game._sdk.init();
        }

        // Scaling
        if (window.innerWidth < window.innerHeight) {
            Game._scale = new ScaleManager(Game._app, new pc.Vec2(560, 760), new pc.Vec2(560, 1220));
        }
        else {
            Game._scale = new ScaleManager(Game._app, new pc.Vec2(800, 560), new pc.Vec2(1220, 560));
        }

        Game._scale.resize();

        // Loader
        Game._app.assets.on(AssetLoader.EVENT_LOADED, this.handleLoaderComplete, this);

        Game._loader = new AssetLoader(Game._app.assets, "assets/");

        // Modely
        Game._loader.addAsset(eModelAsset.tileFan_0, pc.eAssetType.model, "tileFan_0.json");
        Game._loader.addAsset(eModelAsset.tileFragile_0, pc.eAssetType.model, "tileFragile_0.json");
        Game._loader.addAsset(eModelAsset.tileSolid_0, pc.eAssetType.model, "tileSolid_0.json");
        Game._loader.addAsset(eModelAsset.tileSolid_1, pc.eAssetType.model, "tileSolid_1.json");
        Game._loader.addAsset(eModelAsset.tileSolid_2, pc.eAssetType.model, "tileSolid_2.json");

        Game._loader.addAsset(eModelAsset.obsColumn_0, pc.eAssetType.model, "obsColumn_0.json");
        Game._loader.addAsset(eModelAsset.obsGate_0, pc.eAssetType.model, "obsGate_0.json");
        Game._loader.addAsset(eModelAsset.obsWall_0, pc.eAssetType.model, "obsWall_0.json");
        Game._loader.addAsset(eModelAsset.obsFlying_0, pc.eAssetType.model, "obsFlying_0.json");
        Game._loader.addAsset(eModelAsset.obsRolling_0, pc.eAssetType.model, "obsRolling_0.json");

        Game._loader.addAsset(eModelAsset.laserCannon, pc.eAssetType.model, "laserCannon.json");
        Game._loader.addAsset(eModelAsset.laserBeam, pc.eAssetType.model, "laserBeam.json");

        Game._loader.addAsset(eModelAsset.hammer, pc.eAssetType.model, "hammer.json");
        Game._loader.addAsset(eModelAsset.pillar_0, pc.eAssetType.model, "pillar_0.json");
        Game._loader.addAsset(eModelAsset.pillar_1, pc.eAssetType.model, "pillar_1.json");

        Game._loader.addAsset(eModelAsset.fxFan, pc.eAssetType.model, "fxFan.json");
        Game._loader.addAsset(eModelAsset.fxLaser, pc.eAssetType.model, "fxLaser.json");

        Game._loader.addAsset(eModelAsset.platform1, pc.eAssetType.model, "platform_1.json");
        Game._loader.addAsset(eModelAsset.platform2, pc.eAssetType.model, "platform_2.json");

        Game._loader.addAsset(eModelAsset.bonus_0, pc.eAssetType.model, "bonus_0.json");
        Game._loader.addAsset(eModelAsset.bonus_1, pc.eAssetType.model, "bonus_1.json");

        Game._loader.addAsset(eModelAsset.player, pc.eAssetType.model, "player.json");

        Game._loader.addAsset(eModelAsset.bgRing, pc.eAssetType.model, "bgRing.json");

        // Animace
        Game._loader.addAsset(eAnimAsset.showObsColumn_0, pc.eAssetType.animation, "animObsColumn_0.json");

        // Textury
        Game._loader.addAsset(eTextureAsset.background, pc.eAssetType.texture, "textures/bg_0.png");
        Game._loader.addAsset(eTextureAsset.particles, pc.eAssetType.texture, "textures/particles.png");

        // Atlas
        Game._loader.addAsset(eAtlas_0.NAME, pc.eAssetType.texture, "atlas_0.png");
        Game._loader.addAsset(eAtlas_0.NAME, pc.eAssetType.atlas, "atlas_0.json");

        // Fonty
        Game._loader.addAsset(eFontAsset.default, pc.eAssetType.font, "fonts/UpheavalPro.json");

        // Audio
        Game._loader.addAsset(eAudioAsset.sfx, pc.eAssetType.audio, "audio/sfx.mp3");
        Game._loader.addAsset(eAudioAsset.music, pc.eAssetType.audio, "audio/music.mp3");

        // Level
        for (let i = 0; i < PathGenerator.SECTION_GROUP_CNT; i++)
            Game._loader.addAsset(Game.MAP_ASSET_KEY + i, pc.eAssetType.json, "maps/maps_" + i + ".json");

        Game._loader.load();
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci atlas
     * @param atlasId 
     */
    //-------------------------------------------------------------------------
    static getTextureAtlas(atlasId: number): pc.TextureAtlas {
        return this._textureAtlas;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleLoaderComplete(): void {
        // Ziskat texture atlas
        Game._textureAtlas = Game._app.assets.find(eAtlas_0.NAME, pc.eAssetType.atlas).resource as pc.TextureAtlas;
        Game._sfxSpriteAssetId = Game.app.assets.find(eAudioAsset.sfx, pc.eAssetType.audio).id;

        this.handleInitProgress(Game._FLAG_ASSETS_LOADED);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleInitProgress(progressFlag: number): void {
        this._flags |= progressFlag;

        if ((this._flags & (Game._FLAG_ASSETS_LOADED | Game._FLAG_SDK_INITIALIZED)) == (Game._FLAG_ASSETS_LOADED | Game._FLAG_SDK_INITIALIZED)) {
            if (Game.API != eGameAPI.GAMEE)
                SaveState.loadFromLocalStorage();

            // Vytvorit gameplay
            this._gameplay = new Gameplay();

            // Spustit herni smycku
            Game._app.on("update", this.handleAppUpdate, this);

            if (Game.API == eGameAPI.GAMEE)
                Gamee.Wrapper.gameReady();
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleAppUpdate(dt: number): void {
        //FPS_METER.tick();

        if (!Game._paused)
            this._gameplay.update(dt);
    }
}



window.addEventListener("DOMContentLoaded", () => {
    new Game("renderCanvas");
});